import React from 'react'

import Label from '../../label'
import Search from '../../form/form-search'
import Checkbox from '../../form/form-checkbox'
import Selector from '../../form/form-select'
import CheckedList from '../list-checked'

export const init = (data, renderer) => ({...data, renderer})

export function dataToUrl(dataForm) {
    const form = {};
    const trueSubTypes = subTypes => subTypes.filter(sybType => sybType[1]).map(subTypes => subTypes[0]).toString()
    const initFilters = (type, subTypes) => subTypes.length && (form[type] = subTypes)

    Object.entries(dataForm)
        .filter(type => type[1])
        .map(val => initFilters(val[0], trueSubTypes(Object.entries(val[1]))))

    return form
}

function initChecksbox(form, filter, onClick){
    const {type, subTypes} = filter
    !form[type] && (form[type] = {})

    return <div className={"checksbox " + type} key={'filter-' + type}>
        <Label>{'app.filters.' + type}</Label>
        <div className="inline">
            {subTypes.map(
                subType => <Checkbox key={'filter-' + type + '-' + subType}
                    value={form[type] && form[type][subType] ? form[type][subType] : false}
                    onClick={() => onClick(form[type][subType] = !form[type][subType])}
                    label={'app.filters.' + subType} />)}
        </div>
    </div>
}

export const checksbox = (type, subTypes) => init({type, subTypes}, initChecksbox)


function initInputSearch(form, filter, onClick){
    let {type} = filter
    !form[type] && (form[type] = "")

    return <div key={'filter-' + type}>
        <Search onSelect={console.log} value={form[type]} onChange={data => {
            form[type] = {}
            form[type][data] = true
            return onClick(form)
        }} label={'app.filters.' + type} placeholder='app.search' />
    </div>
}
export const search = (type, initInputSearch) => init({type}, initInputSearch)


function initTagsList(service) {
    return (form, filter, onClick)=> {
        const {type} = filter
        form[type] = {}
        return <div key={'filter-' + type}>
            <Label>app.filters.{type}</Label>
            <CheckedList className={'filter-' + type}
                collection={Object.keys(form[type])}
                request={data => service.tags(data.value)}
                onSelect={data => {
                    form[type] = {}
                    form[type][data.collection.map(t => t.id).join(',')] = true
                    return onClick(form)
                }}
                placeholder={'app.search'}/>
        </div>
    }
}
export const tagsList = (type, service) => init({type}, initTagsList(service))


function initSelector(form, filter, onClick){
    const {type, subTypes} = filter
    return <div key={'filter-' + type}>
        <Label>app.filters.{type}</Label>
        <Selector className={'filter-' + type}
            key={'filter-' + type}
            value={form[type]}
            options={subTypes.map(t => ({id: t, value:'app.pageType.' + t}))}
            onChange={data => {
                form[type] = {}
                form[type][data] = true
                return onClick(form)
            }} />
    </div>
}
export const selector = (type, subTypes) => init({type, subTypes}, initSelector)




